import moment from 'moment';
import {toPhilMoment} from '@/utils/dates';
import {
  NUMBER_OF_DAYS_AFTER_EXPIRY,
} from "@/reference/app-constants";
import {
  STATUS_CODES,
  CANCELLED_STATUSES,
  COUPON_STATUS,
} from '@/reference/medicine';

export const couponExpirationDate = (coupon) => {
  if (!coupon) return null;
  const issueDate = toPhilMoment(coupon.issuedate);
  return issueDate.clone().add(NUMBER_OF_DAYS_AFTER_EXPIRY, 'days');
};

export const isCouponExpired = (coupon) => {
  if (!coupon) return false;
  return moment().isAfter(couponExpirationDate(coupon));
};

export const canAvailCoupon = (coupon) => {
  if (!coupon) return false;

  return [
    COUPON_STATUS.ISSUED,
    COUPON_STATUS.AVAILED,
  ].includes(coupon.status);
};

export const getPrescriptionCoupon = (prescription) => {
  if (!!prescription.coupons && Array.isArray(prescription.coupons)) {
    return prescription.coupons[0];
  }

  return null;
};

export const isOrderCancelled = (orderStatus) => {
  return orderStatus && CANCELLED_STATUSES.includes(orderStatus);
};

export const orderStatusLabelId = (orderStatus) => {
  if (!orderStatus) return 'txt117';

  if (isOrderCancelled(orderStatus)) return 'txt119';

  switch (orderStatus) {
    case STATUS_CODES.PENDING:
      return 'txt207';

    case STATUS_CODES.CONFIRMED:
      return 'txt207';

    case STATUS_CODES.DELIVERING:
      return 'txt228';

    case STATUS_CODES.PROC_FAILED_DELIVERY:
      return 'txt334';

    case STATUS_CODES.FULFILLED:
      return 'txt229';

    case STATUS_CODES.AWAITING_PAYMENT:
      return 'txt619';

    case STATUS_CODES.PROCESSING:
    default:
      return 'txt117';
  }
};

export const isCouponProgram = (coupon) => coupon ? !!coupon.programid : false;